/**
 * @desc 修改模型
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(
  body: defs.activiti.ActivitiModelRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/activiti/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
